import { render, staticRenderFns } from "./SitchEmailSelect.vue?vue&type=template&id=1b1c01e0&scoped=true&"
import script from "./SitchEmailSelect.vue?vue&type=script&lang=ts&"
export * from "./SitchEmailSelect.vue?vue&type=script&lang=ts&"
import style0 from "./SitchEmailSelect.vue?vue&type=style&index=0&id=1b1c01e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1c01e0",
  null
  
)

export default component.exports